import Vue from "vue";
import Router from "vue-router";
import login from "@/components/login/Login";
import index from "@/components/index";
import readTask from "@/components/readTask/index";
import read from "@/components/read/index";
import platform from "@/components/platform/platform";
import resources from "@/components/platform/resources";
import readresources from "@/components/read/resources";
import resourcesadd from "@/components/read/add";
import readBook from "@/components/read/newly";
import readBill from "@/components/read/newBill";
import statistics_read from "@/components/statistics/read";
import statistics_read_org from "@/components/statistics/orgRead";
import readdetails from "@/components/read/details";
import pdf from "@/components/read/pdf";
import readTask_details from "@/components/readTask/details";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/index",
      name: "index",
      component: index,
      meta: {
        keepAlive: true,
        isBack: true,
        title: "首页"
      }
    },
    {
      path: "/readdetails",
      name: "readdetails",
      component: readdetails,
      meta: {
        keepAlive: false,
        isBack: false,
        title: "资源详情"
      }
    },
    {
      path: "/pdf",
      name: "pdf",
      component: pdf,
      meta: {
        keepAlive: false,
        isBack: false,
        title: "资源详情"
      }
    },
    {
      path: "/resources",
      name: "resources",
      component: resources,
      meta: {
        keepAlive: true,
        isBack: true,
        title: "平台资源"
      }
    },
    {
      path: "/readresources",
      name: "readresources",
      component: readresources,
      meta: {
        keepAlive: true,
        isBack: true,
        title: "校本资源"
      }
    },
    {
      path: "/resourcesadd",
      name: "resourcesadd",
      component: resourcesadd,
      meta: {
        keepAlive: false,
        isBack: false,
        title: "资源"
      }
    },
    {
      path: "/platform",
      name: "platform",
      component: platform,
      meta: {
        keepAlive: true,
        isBack: true,
        title: "平台书库"
      }
    },
    {
      path: "/readTask",
      name: "readTask",
      component: readTask,
      meta: {
        keepAlive: true,
        isBack: true,
        title: "阅读任务"
      }
    },
    {
      path: "/readTask_details",
      name: "readTask_details",
      component: readTask_details,
      meta: {
        keepAlive: false,
        isBack: false,
        title: "阅读任务详情"
      }
    },
    {
      path: "/read",
      name: "read",
      component: read,
      meta: {
        keepAlive: true,
        isBack: true,
        title: "图书管理"
      }
    },
    {
      path: "/readBook",
      name: "readBook",
      component: readBook,
      meta: {
        keepAlive: false,
        isBack: true,
        title: "阅读书籍"
      }
    },
    {
      path: "/statistics",
      name: "statistics_read",
      component: statistics_read,
      meta: {
        keepAlive: false,
        isBack: true,
        title: "阅读统计"
      }
    },
    {
      path: "/statistics_org",
      name: "statistics_read_org",
      component: statistics_read_org,
      meta: {
        keepAlive: false,
        isBack: true,
        title: "区级阅读统计"
      }
    },
    {
      path: "/readBill",
      name: "readBill",
      component: readBill,
      meta: {
        keepAlive: false,
        isBack: true,
        title: "阅读书单"
      }
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: {
        keepAlive: false,
        isBack: true,
        title: "登录"
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0
      };
    }
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js